import React from "react";

const Cheese = () => {
  return <img src={require("../BurgerAssets/cheese.svg")} alt="" />;
};

export default Cheese;
